import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoadingStore = defineStore('loading', () => {
  const isLoading = ref<number[]>([])
  const loadingMessage = ref<string>("")

  const startLoading = () => { 
    isLoading.value.push(1);
    loadingMessage.value = "";
  }
  const changeLoadingMessage = (text: string) => {
    loadingMessage.value = text;
  }
  const stopLoading = () => { isLoading.value.pop() }

  return { isLoading, loadingMessage, startLoading, stopLoading, changeLoadingMessage }
})